<script setup lang="ts">
import { POSTIT_CATEGORY_ENUM, type Postit } from "@gasparigit/omnia-sdk";

defineProps<{
  content: Postit;
  compact?: boolean;
  showAreas?: boolean;
}>();
</script>

<template>
  <FrontContentItemsBaseContent v-bind="$props">
    <template #preview>
      <img
        loading="lazy"
        v-if="content.image"
        :src="content.image?.original_url || undefined"
        :srcset="content.image?.srcset || undefined"
        class="mx-auto object-cover aspect-square max-h-28 mb-2 md:mb-0"
        :alt="content.title"
      />
    </template>
    <template #footer>
      <div v-if="!compact && content.categories?.length" class="flex flex-wrap gap-x-2 font-semibold text-base pt-2 mt-auto">
        <span v-for="category in content.categories" class="text-tertiary">{{ POSTIT_CATEGORY_ENUM[category] }}</span>
      </div>
    </template>
  </FrontContentItemsBaseContent>
</template>
